import { createId } from "../../../app/runtimeContext";

import type { WorkPackage } from "./agentExecutionContract";

import type { AppendWorkFactory } from "./cyanTakeoverChatController";

import type { CyanOperationalSession } from "./cyanOperationalSessionService";

/**
 * Converts a newly agreed owner decision into a bounded,
 * reversible queue item.
 *
 * Detailed decomposition can later be delegated to the planning
 * layer, but this bridge never grants production authority.
 */
export class CyanOwnerDecisionWorkFactory implements AppendWorkFactory {
  create(
    objective: string,

    session: CyanOperationalSession,
  ): readonly WorkPackage[] {
    const normalized = objective.trim();

    if (!normalized) {
      return [];
    }

    return [
      {
        id: createId("owner_work"),

        phaseId: "owner-addition",

        department: "ENGINEERING",

        agentRole: "SPECIALIST",

        objective: normalized,

        instructions: [
          "Implement the owner-approved addition without disrupting independent work already in progress.",
          "Inspect current SPEC and execution-program state before changing files.",
          "Respect resource locks and existing dependencies.",
          "Run relevant tests and provide evidence before marking complete.",
        ],

        dependencies: [],

        blocks: [],

        resourceScope: {
          paths: [],

          services: [],

          integrations: [],
        },

        authorities: ["READ", "WORKSPACE_WRITE", "TEST_EXECUTION", "GIT_LOCAL"],

        definitionOfDone: [
          "Owner-requested addition is implemented.",
          "Relevant tests pass.",
          "No unrelated regression is introduced.",
          "Execution evidence is attached.",
        ],

        mayRunInParallel: Boolean(session.programId),
      },
    ];
  }
}
